import React, { useEffect, useState } from 'react';
import CartShippingAddress from "./CartShippingAddress"
import CartManuallyAddPart from "./CartManuallyAddPart"
import ClearCart from "../../../component/Global/Cart/ClearCart"
import CartList from "./CartList"
import Notification from "./Notification";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import SystemAlerts from "../../../component/SystemAlerts";
import { useCartStore } from 'src/hooks/cart';
import FadeInOut from "../../../component/FadeInOut";
import AlertContentWithFlag from 'src/pages/Checkout/AlertContentWithFlag';
import useReduxState from 'src/hooks/useReduxState';
import Helper from 'src/support/Helper';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import ReusableDiv from "../../../support/ReusableDiv";

const CartLeftContent = (props) => {
    const [{ CART_DATA }, { }, { }] = useCartStore();
    const [__check] = useAxiosIndicatorCheck();
    const [productAvailableError, setProductAvailableError] = React.useState(false);
    const [isCartPriceAlert] = useReduxState(false, 'setCartPriceAlert')
    const [isVendorExcluded] = useReduxState(false, 'setIsVendorExcluded')
    const [isCheckoutCharge] = useReduxState('', 'setCheckoutCharge');

    //By Ramya [Error details - Adobe script]
    const [isErrorEvent, setErrorEvent] = useState(true);
    useEffect(() => {
        if (isCartPriceAlert && isErrorEvent) {
            errorDetailsEvent();
            setErrorEvent(false);
        }
    }, [isCartPriceAlert]);

    function errorDetailsEvent() {
        localStorage.setItem("adobeEventType", "errorEvent");
        let errorDetails = {
            errorMSG: "There is a Price Mismatch between the Min/Mult and available tier price. To proceed, please update the quantity or remove the items from your cart.",
            location: "cartView",
            errorName: "priceAlert"
        }
        if (Object.keys(errorDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ errorDetails });
        }

    }
    return (
        <>
            {ReusableDiv.CartDisclaimerMessage()}
            <div className="col-xl-9">
                <div className="col-12 m1-3">
                    <div>
                        {/* {Helper.valueIsNotNull(isCheckoutCharge) && */}
                            <AlertContentWithFlag message={`Service charge: Avnet charges a ${isCheckoutCharge}%  of the respective invoice amount due to increased costs and efforts in areas such as compliance, environment, ESG, handling and others.`} type="warning" isDisplay={true} isDisplayIcon={false} />
                        {/* } */}
                        <SystemAlerts />
                        {isCartPriceAlert &&
                            <AlertContentWithFlag message={'<span>Error: There is a Price Mismatch between the Min/Mult and available tier price. To proceed, please update the quantity or remove the items from your cart.</span>'} type="danger" isDisplay={false} isDisplayIcon={true} />
                        }
                        {productAvailableError &&
                            <AlertContentWithFlag message={'<span>The part(s) in your cart cannot be shipped to your current <b>shipping country</b>. Please remove them to proceed to Checkout.</span>'} type="danger" isDisplay={false} isDisplayIcon={true} />
                        }
                        {isVendorExcluded &&
                            <AlertContentWithFlag message={'<span>The part(s) in your cart are not eligible. Please remove them to proceed to Checkout.</span>'} type="danger" isDisplay={false} isDisplayIcon={true} />
                        }
                    </div>

                    {(!__check(['CART_API_CALL', 'VIEW_CART_API_CALL']).status) && !(CART_DATA && Object.entries(CART_DATA).length > 0 &&
                        CART_DATA.length > 0) &&
                        <>
                            <FadeInOut show={true}
                                duration={1000} style={{}} className="alert alert-info text-center mb-2">
                                <span>Your Shopping Cart is Empty.</span>
                            </FadeInOut>
                        </>
                    }
                </div>
                <CartShippingAddress />
                <CartManuallyAddPart />
                <div className={'pt-1 pb-1'}>
                    <Notification setProductAvailableError={setProductAvailableError} />
                </div>
                <div className={'pt-2 pb-2'}>
                    <ClearCart />
                </div>
                <CartList />

            </div>
        </>
    );
}

export default CartLeftContent;